var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
var GET_LAST_ACCESSED_ORGANIZATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getLastAccessedOrganization {\n    lastAccessedOrganization @client {\n      id\n      name\n    }\n  }\n"], ["\n  query getLastAccessedOrganization {\n    lastAccessedOrganization @client {\n      id\n      name\n    }\n  }\n"])));
export default GET_LAST_ACCESSED_ORGANIZATION;
var templateObject_1;
